export default __webpack_public_path__ + "static/media/substance.22ea6333.svg";